import { themeVar } from '../tenantTheme';


// Chakra emits these as `--chakra-fonts-{heading,body}`, so every consumer of the `heading`/`body`
// font token resolves through the `--peli-fonts-*` indirection. The `var()` fallback keeps the
// Inter stack rendering when no tenant override is set.
//
// A family override on its own is inert unless the face is loaded - `fonts.url` is injected as a
// <link rel="stylesheet"> by `utils/applyThemeVars.ts#ensureFontLink`, not as a CSS variable.
export default {
  heading: themeVar('fonts.heading', '"Inter", -apple-system, system-ui, sans-serif'),
  body: themeVar('fonts.body', '"Inter", -apple-system, system-ui, sans-serif'),
};
